import styled from "styled-components";

import { colorsPalettes, rgba } from "@similarweb/styles";

export const StyledOverlay = styled.div`
    animation: overlay-appear 200ms ease-in-out forwards;
    background-color: ${rgba(colorsPalettes.midnight["300"], 0.7)};
    height: 100vh;
    left: 0;
    opacity: 0;
    position: fixed;
    top: 0;
    width: 100vw;
    z-index: 99999;

    @keyframes overlay-appear {
        to {
            opacity: 1;
        }
    }
`;
